/**
 * Viza qiymətləri cədvəlinin ölkə filtri.
 *
 * Cədvəldə 60-dan çox sətir var; istifadəçi adətən bir ölkə axtarır.
 * Filtr sadəcə sətirləri gizlədir — server sorğusu yoxdur, JS sönülü olanda
 * isə cədvəl olduğu kimi tam görünür.
 */
export default function initVisaPrices() {
  const input = document.querySelector('[data-visa-prices-filter]');
  const table = document.querySelector('[data-visa-prices-table]');

  if (!input || !table) {
    return;
  }

  const rows = Array.from(table.querySelectorAll('[data-visa-prices-row]'));
  const empty = document.querySelector('[data-visa-prices-empty]');

  const apply = () => {
    const query = input.value.trim().toLocaleLowerCase('az');
    let visible = 0;

    rows.forEach((row) => {
      const match = query === '' || (row.dataset.country || '').indexOf(query) !== -1;

      row.hidden = !match;

      if (match) {
        visible += 1;
      }
    });

    if (empty) {
      empty.hidden = visible !== 0;
    }
  };

  input.addEventListener('input', apply);
}
